import {
  ChildrenDocument,
  ChildrenDocumentAttachment,
  ChildrenDocumentMissing,
  FolderName,
} from '../../models/document'
import { DocumentRowAttachmentsItem } from './DocumentRowAttachmentsItem'
import { DocumentRowItem } from './DocumentRowItem'

interface DocumentRowProps {
  document: ChildrenDocument | ChildrenDocumentMissing
  refetchDocuments: () => Promise<any>
  displayFolders: FolderName[]
  onDocumentOpen?: (
    document: ChildrenDocument | ChildrenDocumentMissing,
    attachments?: ChildrenDocumentAttachment[]
  ) => React.ReactNode
  renderDocumentAction?: (
    document: ChildrenDocument | ChildrenDocumentMissing,
    attachments?: ChildrenDocumentAttachment[],
    refetchDocuments?: () => Promise<any>
  ) => React.ReactNode
}

export function DocumentRow({
  document,
  refetchDocuments,
  displayFolders,
  onDocumentOpen,
  renderDocumentAction,
}: DocumentRowProps) {
  if (!displayFolders.includes(document.folderName)) {
    return null
  }

  if ('documentAttachmentVersions' in document && document.documentAttachmentVersions?.length > 1) {
    return (
      <DocumentRowAttachmentsItem
        document={document}
        onDocumentOpen={onDocumentOpen}
        renderDocumentAction={renderDocumentAction}
      />
    )
  }

  return (
    <DocumentRowItem
      document={document}
      onDocumentOpen={onDocumentOpen}
      renderDocumentAction={renderDocumentAction}
      refetchDocuments={refetchDocuments}
    />
  )
}
